export enum PolicyComponentTypes {
    AND = "AND",
    OR = "OR",
    LIST = "LIST"
}